import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/api";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <h1 className="text-2xl font-head font-bold text-slate-900 mb-1">Audit Trail</h1>
      <p className="text-sm text-slate-500 mb-4">Every key action is recorded, including Amden support access.</p>
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto scroll-thin">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr>{["When", "User", "Action", "Entity", "Reference"].map((h) => <th key={h} className="text-left font-medium text-slate-500 px-3 py-2.5">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`} className={`border-t border-slate-100 ${r.highlight === "orange" ? "bg-orange-50" : ""}`}>
                <td className="px-3 py-2.5 text-slate-500 whitespace-nowrap">{new Date(r.timestamp).toLocaleString()}</td>
                <td className="px-3 py-2.5 text-slate-700">{r.user_name || "—"}</td>
                <td className="px-3 py-2.5"><span className={`text-xs font-medium rounded px-2 py-0.5 ${r.highlight === "orange" ? "bg-orange-500 text-white" : "bg-slate-100"}`}>{r.action}</span></td>
                <td className="px-3 py-2.5 text-slate-600">{r.entity}</td>
                <td className="px-3 py-2.5 text-slate-500">{r.record_ref || r.entity_id || "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400">No audit records yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
